const defaultErrorMessage = 'Не удалось активировать сертификат. Попробуйте ещё раз.';

export const certificateActivationErrorMessage = error => {
    if (error?.response?.data?.message) {
        return error.response.data.message;
    }

    if (error?.code === 'ECONNABORTED') {
        return 'Сервер не ответил вовремя. Сертификат не активирован — попробуйте ещё раз.';
    }

    return defaultErrorMessage;
};

export const runCertificateActivation = async ({
    nominal,
    activate,
    setLoading,
    setMessage,
}) => {
    setLoading(true);

    try {
        const response = await activate(nominal);
        setMessage(response?.message || 'Сертификат активирован');
        return true;
    } catch (error) {
        setMessage(certificateActivationErrorMessage(error));
        return false;
    } finally {
        setLoading(false);
    }
};
